import React from 'react'
import { CircularProgress, LinearProgress } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ImportRunState } from './useImportWizard'

export default function ResultStep({ run }: { run: ImportRunState }) {
  const { t } = useTranslation()
  const processed = run.created + run.failed.length
  const percent = run.total ? Math.round((processed / run.total) * 100) : 0

  if (run.status === 'running') {
    const started = processed > 0
    return (
      <div className="action-import-state" role="status" aria-live="polite">
        <CircularProgress size={34} sx={{ color: '#076B5C' }} aria-hidden />
        <h4>{t('actionImport.result.importing', { done: processed, total: run.total })}</h4>
        <div className="action-import-progress">
          <LinearProgress
            variant={started ? 'determinate' : 'indeterminate'}
            value={started ? percent : undefined}
            sx={{ height: 8, borderRadius: 4, '& .MuiLinearProgress-bar': { backgroundColor: '#076B5C' } }}
            aria-label={t('actionImport.result.progress')}
          />
          {started ? <span>{percent}%</span> : null}
        </div>
        <p>{t('actionImport.result.keepOpen')}</p>
      </div>
    )
  }

  const allOk = !run.failed.length

  return (
    <div className="action-import-result">
      <div className={`action-import-state ${allOk ? 'is-success' : 'is-warning'}`} role="status">
        <h4>{allOk ? t('actionImport.result.successTitle') : t('actionImport.result.partialTitle')}</h4>
        <div className="action-import-result-stats">
          <div className="is-ok">
            <b>{run.created}</b>
            <span>{t('actionImport.result.created')}</span>
          </div>
          <div className={run.failed.length ? 'is-error' : ''}>
            <b>{run.failed.length}</b>
            <span>{t('actionImport.result.failed')}</span>
          </div>
        </div>
        {!allOk ? <p>{t('actionImport.result.partialHint')}</p> : null}
      </div>

      {run.failed.length ? (
        <ul className="action-import-failures" aria-label={t('actionImport.result.failures')}>
          {run.failed.map((f) => (
            <li key={f.rowId}>
              <b>{f.name || t('actionImport.result.untitled')}</b>
              <span>{f.message}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}
